import { DecimalPipe } from '@angular/common';
import * as lpn from 'google-libphonenumber';
import {
  IAddress,
  IAddressV2,
} from '@carm/shared/components/form-elements/models';
import { ProgramTypes } from '@carm/_core';
import { Country, IntTelFormGroupModel } from '@carm/shared/components/telephone-int/models/telephone-model';
import { ALL_COUNTRIES } from '@carm/shared/components/telephone-int/country-code';
import { dateTimeFormat } from '@carm/shared/constants/const-carm';
import * as dayjs from 'dayjs';
import { AbstractControl, FormArray, UntypedFormGroup } from '@angular/forms';

export function convertToUTCDate(date: any): Date {
  return date && date !== '' && date !== '9999-12-31'
    ? new Date(
      new Date(date).getTime() + new Date(date).getTimezoneOffset() * 60000
    )
    : undefined;
}

export function utcStartDayTime(startDate?: Date) {
  return startDate
    ? dayjs(startDate).startOf('day').utc().format(dateTimeFormat)
    : dayjs().subtract(100, 'years').startOf('day').utc().format(dateTimeFormat)
}

export function utcEndDayTime(endDate?: Date) {
  return endDate
    ? dayjs(endDate).endOf('day').utc().format(dateTimeFormat)
    : dayjs().endOf('day').utc().format(dateTimeFormat)
}

export function stringEmptyOrNull(data: string): boolean {
  return data && data.trim().length > 0 ? false : true;
}

export function standardCarmMoneyFormat(
  decimalPipe: DecimalPipe,
  value: number,
  currencySymbol?: string,
  lang?: string
): string {
  if (value != null) {
    if ('fr' === lang) {
      return `${decimalPipe.transform(value, '1.2-2')} $ ${currencySymbol || ''}`.trim();
    } else {
      return `$${decimalPipe.transform(value, '1.2-2')} ${currencySymbol || ''}`.trim();
    }
  } else {
    return '';
  }
}

export function formatAddress(address: IAddress): string {
  if (address) {
    return `${address.line1}${address.line2 ? ' ' + address.line2 + ',' : ','
      } ${address.town || ''}, ${address.carmRegion || ''}, ${address.carmCountry || ''
      }, ${address.postalCode || ''}`;
  }
}

export function formatAddressV2(address: IAddressV2): string {
  if (address) {
    return `${address.line1}${address.line2 ? ' ' + address.line2 + ',' : ','
      } ${address.town || ''}, ${address.region || ''}, ${address.country || ''
      }, ${address.postalCode || ''}`;
  }
}

export function isThirdParty(programType: ProgramTypes) {
  const thirdParty = [
    ProgramTypes.ThirdPartyServiceProvider,
    ProgramTypes.ThirdPartyServiceProviderAcountant,
    ProgramTypes.ThirdPartyServiceProviderConsultant,
    ProgramTypes.ThirdPartyServiceProviderEDI,
    ProgramTypes.ThirdPartyServiceProviderLawyer,
    ProgramTypes.ThirdPartyServiceProviderSurety,
  ];

  return thirdParty.includes(programType) ? true : false;
}

export function checkIfArraysIntersect(arr: string[], target: string[]) {
  return target.every(v => arr.includes(v));
}

export function parsePhoneNumber(rawNumber: string): lpn.PhoneNumber {
  const phoneUtil = lpn.PhoneNumberUtil.getInstance();
  return phoneUtil.parseAndKeepRawInput(rawNumber, null);
}

export function parsePhoneNumberToIntTelFormGroup(rawNumber: string): IntTelFormGroupModel {

  if(!rawNumber){
    return {
      countryDialCode: null,
      e164Phone: null,
      phoneNumber: null,
    }
  }


  try { // added execption handling to handle existing bad data
    const phoneUtil = lpn.PhoneNumberUtil.getInstance();
    const number = phoneUtil.parseAndKeepRawInput(rawNumber, null);
    const regionCode = phoneUtil.getRegionCodeForNumber(number)?.toLowerCase();
    let selectedCountry = ALL_COUNTRIES.find((country: Country, index) => {
      if (country?.iso2.toLowerCase() === regionCode)
        return ALL_COUNTRIES[index];
    });
    const nationalPhoneNumber = rawNumber.substring(number.getCountryCode().toString().length + 1);

    return {
      countryDialCode: selectedCountry,
      e164Phone: rawNumber,
      phoneNumber: nationalPhoneNumber,
    }
  } catch (e) {
    return {
      countryDialCode: rawNumber ? {} as Country : null,
      e164Phone: null,
      phoneNumber: rawNumber,
    }
  }
}

export function removeAllValidators(control: AbstractControl) {
  if (control instanceof UntypedFormGroup) {
    Object.keys(control.controls).forEach((key) => {
      removeAllValidators(control.get(key)!);
    });
  } else if (control instanceof FormArray) {
    control.controls.forEach((childControl) => {
      removeAllValidators(childControl);
    });
  } else {
    control.clearValidators();
    control.updateValueAndValidity();
  }
}
